/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker header separate styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

export const DatePickerHeaderSeparateCategory = styled.div`
    display: grid;
    grid-row-gap: 8px;
`;

export const DatePickerHeaderTitleSeparateStyled = styled.div.attrs({
    className: 'date-picker__header-title',
})`
    flex-grow: 1;
    padding: 0 12px;
`
